(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/step-indicator/assets/javascripts/step-indicator.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/step-indicator/assets/javascripts/step-indicator.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState;
const mockableImports = {
  Button: svs.ui.ReactButton
};
const MAX_AMOUNT_OF_VISIBLE_STEPS = 6;

const StepIndicator = props => {
  const branding = props.branding,
    daysPerStep = props.daysPerStep,
    handleClickByIndex = props.handleClickByIndex,
    steps = props.steps,
    numberOfActiveSteps = props.numberOfActiveSteps,
    isInvertedButtons = props.isInvertedButtons;
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  const itemSpacerClasses = ['competition-step-indicator-item-spacer'];
  if (isInvertedButtons) {
    itemSpacerClasses.push('inverted');
  }
  let prevDate = null;
  let stepLabels;
  if (steps) {
    stepLabels = steps.map(item => {
      if (item.date) {
        prevDate = new Date(item.date);
      } else if (prevDate) {
        prevDate = new Date(prevDate.getFullYear(), prevDate.getMonth(), prevDate.getDate() + daysPerStep);
      }
      if (item.label) {
        return item.label;
      }
      if (prevDate instanceof Date) {
        return "".concat(prevDate.getDate(), "/").concat(prevDate.getMonth() + 1);
      }
      return '';
    });
  }
  return React.createElement("div", {
    "aria-label": "V\xE4lj omg\xE5ng",
    className: "competition-step-indicator",
    role: "radiogroup"
  }, stepLabels.slice(0, MAX_AMOUNT_OF_VISIBLE_STEPS).map((label, index) =>
  React.createElement(React.Fragment, {
    key: "".concat(label, "_").concat(index)
  }, index === 0 ? null : React.createElement("div", {
    className: itemSpacerClasses.join(' ')
  }), React.createElement(StepIndicatorItem, {
    branding: branding,
    buttonText: label,
    handleClick: handleClickByIndex,
    index: index,
    isActive: index < numberOfActiveSteps,
    isInvertedButtons: isInvertedButtons,
    selectedIndex: selectedIndex,
    setSelectedIndex: setSelectedIndex
  }))));
};
const getButtonSetup = (isInvertedButtons, isActive, isSelected) => {
  if (isInvertedButtons) {
    return {
      inverted: !isSelected,
      transparent: !isSelected
    };
  }
  return {
    inverted: isSelected && isActive,
    transparent: !isSelected || !isActive
  };
};
const StepIndicatorItem = props => {
  const branding = props.branding,
    isActive = props.isActive,
    buttonText = props.buttonText,
    index = props.index,
    handleClick = props.handleClick,
    selectedIndex = props.selectedIndex,
    setSelectedIndex = props.setSelectedIndex,
    isInvertedButtons = props.isInvertedButtons;
  const Button = mockableImports.Button;
  const isSelected = selectedIndex === index;
  const buttonSettings = getButtonSetup(isInvertedButtons, isActive, isSelected);
  const buttonClasses = ['qa-competition-step-indicator-item-button competition-step-indicator-item-button'];
  if (isActive) {
    buttonClasses.push('competition-step-indicator-item-button-active');
  }
  if (isSelected) {
    buttonClasses.push('competition-step-indicator-item-button-selected');
  }
  if (branding) {
    buttonClasses.push("competition-step-indicator-item-button-".concat(branding));
  }
  return React.createElement("div", {
    className: "competition-step-indicator-item"
  }, React.createElement(Button, {
    "aria-checked": isSelected,
    "aria-label": "Omg\xE5ng ".concat(buttonText),
    block: true,
    className: buttonClasses.join(' '),
    disabled: !isActive,
    inverted: buttonSettings.inverted,
    onClick: typeof handleClick === 'function' ? () => {
      const selected = index === selectedIndex ? undefined : index;
      setSelectedIndex(selected);
      handleClick(index);
    } : null,
    role: "radio",
    transparent: buttonSettings.transparent
  }, buttonText));
};
StepIndicator.defaultProps = {
  daysPerStep: 7,
  handleClickByIndex: null
};
StepIndicator._testInternals = {
  getMockableImports: () => mockableImports
};
setGlobal('svs.components.marketplaceShared.stepIndicator.StepIndicator', StepIndicator);

 })(window);